import { MDBModalBody } from "mdb-react-ui-kit";
import PolicyContent from "../policy/policy.content";
import FullModal from "./full.modal";

export default function PolicyReaderModal({ show, policy, onClose }) {
  return (
    <FullModal
      independent
      show={show}
      close={onClose}
      showCloseButton
      centered
      screenSize="lg"
      className="product-action-modal policy-reader-modal"
      dialogClassName="action-modal-dialog policy-reader-dialog"
      contentClassName="policy-reader-content"
      content={
        <MDBModalBody className="policy-reader-body">
          <PolicyContent policy={policy} />

        </MDBModalBody>
      }
    />
  );
}
